<template>
  <div :id="id" :class="mapclass">

  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  props: {
    agenzia:String,
    apikey: String,
    latitude: {
        default : 0,
        type:Number
    },
    longitude: {
        default : 0,
        type:Number
    },
    mapclass:String,
    markerPrefix:{
      default:'',
      type: String,
    },
    markerIcon:{
      default:'/img/ico/marker.png',
      type:String
    },
    id:{
      default: "map",
      type: String
    },
    zoom:{
      default: 15,
      type: Number
    },
    collegate: {
      type:Boolean,
      defailt: false
    }

  },
  data() {
    return {
      markers: [],
      mapLoaded:false
    };
  },
  beforeMount(){
    this.initGoogle();
  },
  mounted() {
    if(!this.mapLoaded){
      this.createMap();
    }
  },

  methods: {
    initGoogle(){
      if(!window.google || !window.google.maps){

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src  = "https://maps.googleapis.com/maps/api/js?key="+this.apikey;
        document.getElementsByTagName('head')[0].appendChild(script); 
        var context=this;
        this.mapLoaded=true;
        script.onload = function () {
          context.createMap();
        }
      }
    },
    createMap(){
   
      var myCenter = new google.maps.LatLng(this.latitude, this.longitude);
      var myCenterMap = new google.maps.LatLng(this.latitude, this.longitude);
      var mapCanvas = document.getElementById(this.id);
      var nZoom =15;
      var marIcon = new google.maps.MarkerImage(
          this.markerPrefix+this.markerIcon,
          null,
          null,
          null,
      );

      var mapOptions = {
          center: myCenter,
          zoom: nZoom
      };

      var map = new google.maps.Map(mapCanvas, mapOptions);
      var marker = new google.maps.Marker({
          position: myCenter,
          icon: marIcon,
          map: map,
          animation: google.maps.Animation.DROP
      });
 
      if(this.collegate && this.agenzia){
        
        var bounds = new google.maps.LatLngBounds();
        var infoWindow = new google.maps.InfoWindow();
        var nMark = 0;
        var context=this;
        $.ajax({
            url: '/ajax/getagenzietecno/'+this.agenzia,
        })
        .done(function(data) {

            bounds.extend(marker.position);
            if(data.agenzie){
                nMark = data.agenzie.length;
                $.each(data.agenzie,function(index, el) {

                context.addMarker(map,bounds,infoWindow,el);

                });

                if(nMark > 0){
                    map.setZoom(map.getZoom()-2);
                }
            }


        })
        .fail(function() {
            console.log("error");
        });
      }

    },
    addMarker(map,bounds,infoWindow,el){
      var iconMarkerTec = this.markerPrefix+'/img/ico/ico_mappa_tre.png';
      var iconMarkerTecOver = this.markerPrefix+'/img/ico/ico_mappa_treOver.png';
      if(el.RETE == 'tec'){
            iconMarkerTec = this.markerPrefix+'/img/ico/ico_mappa_tec.png';
            iconMarkerTecOver = this.markerPrefix+'/img/ico/ico_mappa_tecOver.png';
      }

      var marIconTec = new google.maps.MarkerImage(
          iconMarkerTec,
          null,
          null,
          null,
      );

      var marIconTec2 = new google.maps.MarkerImage(
          iconMarkerTecOver,
          null, /* size is determined at runtime */
          null, /* origin is 0,0 */
          null, /* anchor is bottom center of the scaled image */
      );

      var latlngTec = new google.maps.LatLng(el.P_LATITUDINE,el.P_LONGITUDINE);

      bounds.extend(latlngTec);

     var sSitoWebDesc =
        el["HOMEPAGE_ATTIVA"] == "1" && el["P_URLMINISITO"] !== null
          ? '<a href="' + el["P_URLMINISITO"] + '" target="_blank"> Vista el sitio web </a><p/>'
          : "";
      var sDescr =
        "<div id='infoWindowCont'><h3 class='titoloRgSoc'><img src='"+this.markerPrefix+"/img/ico/ico_mappa_tec.png' height='40'>" +
        el["S_RAGSOC"] +
        "</h3><p class='indirizzoAgenzia'>" +
        el["S_INDIRIZZO"] +
        ", " +
        el["S_CAP"] +
        ", " +
        el["S_COMUNE"] +
        " (" +
        el["S_SIGLAPRV"] +
        ")</p><div class='row restore-row-margin'><div class='col-xs-8'><p><strong>E-mail:</strong><a href='mailto:" +
        el["EMAIL"] +
        "'> " +
        el["EMAIL"] +
        "</a><br><strong>Tel:</strong><a href='tel:+34" +
        el["S_TELEFONO"] +
        "'> " +
        el["S_TELEFONO"] +
        "</a></p></div><div class='col-xs-4 pl-0'>" +
        sSitoWebDesc +
        "</div></div></div>";

      var markerTec = new google.maps.Marker({
          position:latlngTec,
          icon: marIconTec,
          description: sDescr,
          map: map,
          animation: google.maps.Animation.DROP
      });

      google.maps.event.addListener(markerTec, 'click', function () {
          markerTec.setIcon(marIconTec2);
          infoWindow.setContent(this.description);
          infoWindow.open(map, markerTec);

      });

      google.maps.event.addListener(markerTec, 'mouseover', function () {
          markerTec.setIcon(marIconTec2);
          // infoWindow.open(map, markerTec);

      });
      google.maps.event.addListener(markerTec, 'mouseout', function () {
          markerTec.setIcon(marIconTec);
          markerTec.setAnimation(null);
      });
    }
  }
};
</script>
